import { css } from '@emotion/core';
import { halfSpacing } from 'styles/global_defaults/scaffolding';
import { primary } from 'styles/global_defaults/colors';

export default css`
  position: absolute;
  top: ${halfSpacing}px;
  right: ${halfSpacing}px;
  display: flex;

  .nv-dropdown {
    margin-left: ${halfSpacing}px;

    &:hover {
      .icon {
        color: ${primary};
      }
    }
  }
`;
